import styled from '@emotion/styled'

import LoadingSpinnerBase from 'design-system/components/LoadingSpinner'
import Layout from 'design-system/components/Layout'

const LoadingSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`
const LoadingSpinner = styled(LoadingSpinnerBase)`
  width: 120px;
  height: 120px;
`

const LoadingScreen = () => (
  <Layout>
    <LoadingSpinnerContainer>
      <LoadingSpinner />
    </LoadingSpinnerContainer>
  </Layout>
)

export default LoadingScreen
